import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  GET_CODE_LISTING_MANAGEMENT,
  GET_SCHOOLNAME_FILTER,
} from "../../Actions/types";
import api from "../../../helper/api";
import {
  getcodelistingFailure,
  getcodelistingSuccess,
  getschoolnameFailure,
  getschoolnameSuccess,
} from "../../actions";

function* fetchCodeListingTable(action) {
  try {
    const response = yield api.post(
      "/admin/products/code-list",
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      
      yield call(action?.payload?.callback, response);
      yield put(getcodelistingSuccess({ codedata: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
      yield call(action?.payload?.callback, response);

    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getcodelistingFailure({ codeerror: e }));
  }
}

function* fetchSchoolName(action) {
  try {
    const response = yield api.get(
      `/admin/school/get-school?q=${action?.payload?.form}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response.data);
      yield put(
        getschoolnameSuccess({ getschoolnamedata: response?.data?.data })
      );
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getschoolnameFailure({ schoolnameerror: e }));
  }
}

function* fetchcodeWatcher() {
  yield takeLatest(GET_CODE_LISTING_MANAGEMENT, fetchCodeListingTable);
}
function* fetchschoolNamewatcher() {
  yield takeLatest(GET_SCHOOLNAME_FILTER, fetchSchoolName);
}

export default function* codeManageMentSaga() {
  yield all([fetchcodeWatcher(), fetchschoolNamewatcher()]);
}
